module.exports = __webpack_public_path__ + "static/sea.e1999fd0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sea.jpeg
// module id = 451
// module chunks = 168707334958949